export const enum LinkButtonVariant {
  REGULAR = 'regular',
  OUTLINED = 'outlined',
  DISABLE = 'disable'
}